import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const MultiInboxesKeys = new Set(['broadcasts.number_id', 'workflows.number_id'])

export const isMultiInboxesWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  MultiInboxesKeys.has(filterItem.key)
